<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bc21"
      :custom="{ storage: true }"
      export
      :buttons="toolbarButtons"
      :refresh="{ query: RefreshList }"
    />
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column type="seq" width="60" fixed="left" />
      <vxe-table-column title="昵称">
        <vxe-table-column
          field="reviewer"
          title="昵称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="电话号码">
        <vxe-table-column
          field="pageviews"
          title="电话号码"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="角色">
        <vxe-table-column
          field="reviewer"
          title="角色"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="创建时间">
        <vxe-table-column
          field="pageviews"
          title="创建时间"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column title="操作" width="100" fixed="right" />
        <template>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.page"
      :page-size.sync="listQuery.limit"
      :total="listQuery.totalzong"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { fetchList } from "@/api/article";
export default {
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 13,
        totalzong: 0,
      },
      Pagingconf: [],
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询",
        },
        {
          name: "下拉按钮",
          dropdowns: [
            {
              name: "按钮111",
              code: "btn2",
            },
            {
              name: "按钮222",
              code: "btn3",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      fetchList(this.listQuery).then((response) => {
        this.tableData = response.data.items;
        this.listQuery.totalzong = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.loading = false;
      });
    },

    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage;
      this.listQuery.limit = pageSize;
      this.findList();
    },
    /* footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return 'col-blue'
        } else {
          return 'col-red'
        }
      }
    }, */
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "平均";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "和值";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
    },
  },
};
</script>

<style>
</style>
